import util from '@bmp-vue/core/api/util'

const controller = 'SLC0001Detalhe'
export default Object.assign({}, util.GetCrud(controller, ['getall']), {
  AlterarConciliado (dto) {
    return util.Axios.Post(controller + '/AlterarConciliado', dto)
  }
})
